"use client";

import { c as _c } from "react/compiler-runtime";
export default function CalendarHeaderDays() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="grid text-sm  text-center grid-cols-7 auto-rows-auto mb-3 mt-4"><p className="flex items-center justify-center">Lun</p><p className="flex items-center justify-center">Mar</p><p className="flex items-center justify-center">Mer</p><p className="flex items-center justify-center">Jeu</p><p className="flex items-center justify-center">Ven</p><p className="flex items-center justify-center">Sam</p><p className="flex items-center justify-center">Dim</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}